import { useLingui } from '@lingui/react/macro';

import { useSummaryBackgroundContent } from '@/modules/insuranceExport/constants';
import { useImageFallback } from '@/utils/hooks';

const HEADING_CLASSES = 'vai-m-0 vai-font-bold vai-text-lg vai-mb-2';
const BODY_CLASSES = `vai-font-['proxima-nova'] vai-text-sm vai-m-0 vai-leading-none`;

type ClaimFooterPrintVersionProps = {
  type: 'dmf' | 'resto' | 'rbl' | 'display';
};

export const ClaimFooterPrintVersion = ({
  type,
}: ClaimFooterPrintVersionProps) => {
  const { dmf, rbl, display, resto } = useSummaryBackgroundContent();

  const {
    i18n: { locale },
  } = useLingui();

  const { imgSrc: rblImgSrc, onError: rblOnError } = useImageFallback(
    `/assets/images/rblMeasurementGuide/insdiagram-${locale}.png`,
    '/assets/images/rblMeasurementGuide/insdiagram-en.png',
  );

  return (
    <div
      
      data-testid="claim-footer"
      className="vai-w-full vai-flex vai-flex-col vai-gap-8"
    >
      {type === 'dmf' && (
        <section>
          <h2 className={HEADING_CLASSES}>* {dmf.title}</h2>
          <p className={BODY_CLASSES}>{dmf.body}</p>
        </section>
      )}
      {type === 'resto' && (
        <section>
          <h2 className={HEADING_CLASSES}>** {resto.title}</h2>
          <p className={BODY_CLASSES}>{resto.body}</p>
        </section>
      )}
      {type === 'rbl' && (
        <section>
          <h2 className={HEADING_CLASSES}>{rbl.title}</h2>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <img
            src={rblImgSrc}
            alt="RBL"
            className="rbl-diagram"
            onError={rblOnError}
          />
          <p className={BODY_CLASSES}>{rbl.body}</p>
        </section>
      )}
      {type === 'display' && (
        <section>
          <h2 className={HEADING_CLASSES}>{display.title}</h2>
          <p className={BODY_CLASSES}>{display.body}</p>
        </section>
      )}
    </div>
  );
};
